<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  data() {
        return {
            nomeEmpresa: ''
        };
  },
  watch: {
    $route(to) {
       this.applyBackgroundClass(to);
    }
  },
  mounted() {
    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    this.applyBackgroundClass(this.$route);
  },
  methods:{
     applyBackgroundClass(route) {
      document.body.classList.remove('root-background');

      const path = route.path.toUpperCase();

      if (path === '/LOGIN') {
        document.body.classList.add('root-background');
      } 
    }
  }
}
</script>

<style>
body, html {
  height: 100%;
  margin: 0;

}

.root-background {
  background: url('@/assets/fundoSistemaAtendimento_2.png') !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  background-size: 60% !important;
  background-color: #FFF !important; /* Cor preta para as áreas não cobertas pela imagem */
}

.loading-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  border-top-color: #3b8070;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}




</style>
